import React from "react";
import { withBaseIcon } from "react-icons-kit";
import { chevronCircleLeft } from "react-icons-kit/fa/chevronCircleLeft";
import { chevronCircleRight } from "react-icons-kit/fa/chevronCircleRight";
import { chevronDown } from "react-icons-kit/fa/chevronDown";
import { arrowUnsorted } from "react-icons-kit/typicons/arrowUnsorted";
import { arrowSortedUp } from "react-icons-kit/typicons/arrowSortedUp";
import { arrowSortedDown } from "react-icons-kit/typicons/arrowSortedDown";
import { basic_magnifier } from "react-icons-kit/linea/basic_magnifier";
import { funnel } from "react-icons-kit/ionicons/funnel";
import { download } from "react-icons-kit/feather/download";
import { send } from "react-icons-kit/feather/send";
import { x } from "react-icons-kit/feather/x";
import { ic_account_circle } from "react-icons-kit/md/ic_account_circle";
import { ic_delete_outline } from "react-icons-kit/md/ic_delete_outline";
import { ic_edit } from "react-icons-kit/md/ic_edit";
import { arrows_slim_left } from "react-icons-kit/linea/arrows_slim_left";
import { lineArrowLeft } from "react-icons-kit/oct/lineArrowLeft";
import { lineArrowRight } from "react-icons-kit/oct/lineArrowRight";
import { moon } from "react-icons-kit/entypo/moon";
import { adjustBrightness } from "react-icons-kit/typicons/adjustBrightness";
import { pause } from "react-icons-kit/feather/pause";
import { play } from "react-icons-kit/feather/play";
import { upload } from "react-icons-kit/feather/upload";
import { link } from "react-icons-kit/feather/link";
import { iosHelpOutline } from "react-icons-kit/ionicons/iosHelpOutline";
import { ic_error } from "react-icons-kit/md/ic_error";
import { ic_warning } from "react-icons-kit/md/ic_warning";
import { refresh } from "react-icons-kit/ionicons/refresh";
import { calendar } from "react-icons-kit/feather/calendar";

const IconContainer = withBaseIcon({
  size: 30,
});

export const RefreshIcon = () => (
  <IconContainer
    icon={refresh}
    size={26}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);

export const ArrowLeft = () => (
  <IconContainer
    icon={chevronCircleLeft}
    size={26}
    className="text-off-white-dark dark:text-storm-blue-light transition duration-300"
  />
);
export const ArrowRight = () => (
  <IconContainer
    icon={chevronCircleRight}
    size={26}
    className="text-off-white-dark dark:text-storm-blue-light transition duration-300"
  />
);
export const ArrowDown = () => (
  <IconContainer icon={chevronDown} size={12} className="text-black ml-1" />
);
export const SortingArrows = () => (
  <IconContainer
    icon={arrowUnsorted}
    size={18}
    className="text-sky-blue-dark"
  />
);
export const SortedUp = () => (
  <IconContainer
    icon={arrowSortedUp}
    size={18}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);
export const SortedDown = () => (
  <IconContainer
    icon={arrowSortedDown}
    size={18}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);
export const SearchIcon = () => (
  <IconContainer icon={basic_magnifier} size={18} className="text-black" />
);

export const CalendarIcon = () => (
  <IconContainer
    icon={calendar}
    size={14}
    className="text-off-black-light dark:text-greyed-text transition duration-300"
  />
);

export const FilterIcon = () => (
  <IconContainer
    icon={funnel}
    size={22}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);

export const DownloadIcon = () => (
  <IconContainer
    icon={download}
    size={22}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);

export const LinkIcon = ({ className }: { className?: string } = {}) => (
  <IconContainer
    icon={link}
    size={18}
    className={className ?? "text-storm-blue transition duration-300"}
  />
);

export const Delete = () => (
  <IconContainer
    icon={ic_delete_outline}
    size={22}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);
export const EditPencilIcon = () => (
  <IconContainer
    icon={ic_edit}
    size={16}
    className="text-storm-blue dark:text-primary-off-white transition duration-300"
  />
);
export const DeleteXIcon = () => (
  <IconContainer
    icon={x}
    size={16}
    className="text-primary-orange-dark dark:text-primary-orange transition duration-300"
  />
);
export const SendIcon = () => (
  <IconContainer
    icon={send}
    size={20}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);
export const RemoveIcon = () => (
  <IconContainer
    icon={x}
    size={20}
    className="text-red-500 rounded shadow-xl px-2"
  />
);
export const ProfileIcon = () => (
  <IconContainer
    icon={ic_account_circle}
    size={40}
    className="text-storm-blue bg-sky-blue rounded-full shadow shadow-xs shadow-sky-blue"
  />
);
export const BackArrow = () => (
  <IconContainer icon={arrows_slim_left} size={18} />
);
export const NextArrow = () => (
  <IconContainer icon={lineArrowRight} size={18} />
);
export const PrevArrow = () => <IconContainer icon={lineArrowLeft} size={18} />;
export const BrightMode = () => (
  <IconContainer
    icon={adjustBrightness}
    size={22}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);
export const DarkMode = () => (
  <IconContainer
    icon={moon}
    size={22}
    className="text-storm-blue dark:text-sky-blue-light transition duration-300"
  />
);

export const UploadIcon = () => <IconContainer icon={upload} size={15} />;

export const PauseIcon = () => <IconContainer icon={pause} size={15} />;

export const PlayIcon = () => <IconContainer icon={play} size={15} />;

type InfoIconProps = {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

export const InfoIcon = ({
  size = 26,
  className = "text-off-black-light dark:text-storm-blue-light transition duration-300 pb-2.5 ml-2",
  style,
}: InfoIconProps = {}) => (
  <IconContainer
    icon={iosHelpOutline}
    size={size}
    className={className}
    style={style}
  />
);

export const AttentionIcon = () => (
  <IconContainer icon={ic_error} size={18} className="text-orange-400" />
);

/** Warning triangle in the app's primary-orange family, for warning card headers. */
export const WarningIcon = () => (
  <span aria-hidden="true" className="flex flex-none items-center">
    <IconContainer
      icon={ic_warning}
      size={20}
      className="text-primary-orange-dark transition duration-300 dark:text-primary-orange-light"
    />
  </span>
);

export const QuestionCircleIcon = () => (
  <span aria-hidden="true">
    <IconContainer
      icon={iosHelpOutline}
      size={20}
      className="text-white bg-sky-blue-dark rounded-full p-1"
    />
  </span>
);
